import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  InputCustom,
  Loading,
  HttpError,
  InputMaskCustom
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
class PrepostoForm extends Component {
  constructor() {
    super()
    this.getInitialFields = this.getInitialFields.bind(this)
    this.fillFields = this.fillFields.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.onChangeCPF = this.onChangeCPF.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
    this.onChangeTelefone = this.onChangeTelefone.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.state = {
      telefone: "",
      nome: "",
      cpf: "",
      email: "",
      maskTelefone: "(99) 9999-9999",
      showForm: false
    }
  }

  componentWillMount() {
    this.getInitialFields()
  }

  getInitialFields() {
    ApiHelper.getPreposto(this.props.prepostoId, (preposto, error) => {
      if (preposto) {
        this.fillFields(preposto)
        this.setState(
          {
            showForm: true
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  sendForm() {
    var params = {
      nome: this.state.nome,
      cpf: Util.unmaskField(this.state.cpf),
      email: this.state.email,
      telefone: Util.unmaskField(this.state.telefone),
      contratado_id: this.state.contratado_id
    }
    ApiHelper.updatePreposto(this.props.prepostoId, params, error => {
      if (error) {
        this.handleErrors(error)
      } else {
        this.props.callBackPreposto()
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  fillFields(fields) {
    var currentFields = {
      nome: fields.nome,
      cpf: fields.cpf,
      email: fields.email,
      telefone: fields.telefone,
      contratado_id: fields.contratado_id
    }
    this.setState(currentFields)
  }
  //Mascara de telefone
  onChangeTelefone(event) {
    this.setState({ telefoneError: "" })
    var newValue = event.target.value
    this.setState({ telefone: newValue })
  }
  onKeyDownTelefone(event) {
    var keyPressed = event.key
    var unmaskedField = Util.unmaskField(this.state.telefone)
    if (unmaskedField.length === 10 && !isNaN(keyPressed)) {
      this.setState({
        telefone: this.state.telefone + keyPressed,
        maskTelefone: "(99) 99999-9999"
      })
    } else if (unmaskedField.length === 11 && event.keyCode === 8) {
      this.setState({ maskTelefone: "(99) 9999-9999" })
    }
  }
  onChangeNome(event) {
    this.setState({ nomeError: "" })
    var newValue = event.target.value
    this.setState({ nome: newValue })
  }
  onChangeCPF(event) {
    this.setState({ cpfError: "" })
    var newValue = event.target.value
    this.setState({ cpf: newValue })
  }
  onChangeEmail(event) {
    this.setState({ emailError: "" })
    var newValue = event.target.value
    this.setState({ email: newValue })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    if (!this.state.showForm) {
      return <Loading />
    }
    return (
      <div className="container-fluid">
        <div className="card card-plain">
          <div className="card-header" data-background-color="as-blue">
            <h4 className="title">Editar preposto</h4>
            <p className="category">Editar responsável pela empresa</p>
          </div>
          <div className="row">
            <InputCustom
              error={this.state.nomeError}
              sizeClass="col-md-4"
              label="Nome"
              type="text"
              onChange={this.onChangeNome}
              value={this.state.nome}
            />
            <InputMaskCustom
              error={this.state.cpfError}
              mask="999.999.999-99"
              sizeClass="col-md-2"
              label="CPF"
              type="text"
              onChange={this.onChangeCPF}
              value={this.state.cpf}
            />
            <InputMaskCustom
              error={this.state.telefoneError}
              onKeyDown={this.onKeyDownTelefone}
              mask={this.state.maskTelefone}
              sizeClass="col-md-2"
              label="Telefone"
              type="text"
              onChange={this.onChangeTelefone}
              value={this.state.telefone}
            />
            <InputCustom
              error={this.state.emailError}
              sizeClass="col-md-4"
              label="Email"
              type="text"
              onChange={this.onChangeEmail}
              value={this.state.email || undefined}
            />
          </div>
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-right"
            data-background-color="as-blue"
          >
            Salvar
          </button>
        </div>
      </div>
    )
  }
}
export default withRouter(PrepostoForm)



// WEBPACK FOOTER //
// ./src/views/modais/PrepostoForm.js